import AcademyFrame from '../components/AcademyFrame';

export default function Academy() {
  return <div className="academy-page"><AcademyFrame actor="admin" /></div>;
}
